export function setCurrentProfileId(profileId: string) {
  localStorage.setItem("currentProfileId", profileId);
}

export function getCurrnetProfileId() {
  return localStorage.getItem("currentProfileId");
}
